// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.pane_Y0_wR {
  overflow : auto;
}

.inline_o_Rzu {
  display : inline-block;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/Pane.css"],"names":[],"mappings":";AACA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["\n.pane {\n  overflow : auto;\n}\n\n.inline {\n  display : inline-block;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pane": `pane_Y0_wR`,
	"inline": `inline_o_Rzu`
};
export default ___CSS_LOADER_EXPORT___;
